
import React from 'react';

const Work = () => {
  return (
    <div className='page-basics'>
      <h2 style={{ textAlign: 'center' }}>WORK</h2>
      <p style={{ textAlign: 'left' }}>
        My leadership style is participative, supportive, and empowering, with a strong focus on delivering outcomes.
        I prefer a consultative approach to bring out the best in others.  It’s all about building relationships, and I’m all about mutual respect and transparency.
        Growth and personal development are vital to me.

        <h3>Two Oceans Aquarium Foundation 🐙</h3>

        As Head of Ocean Campus and Operations I was an integral part of an organisation that delivers seamless,
        world-class, experiential and curriculum-aligned ocean and environmental science education from cradle to career.
        The Ocean Literacy, Marine Sciences, and Blue Economy education and training programs have impacted more than a million people.
        My main focus was:
        <ul>
          <li>Management of the Ocean Campus and its people for effective sustainability</li>
          <li>Operations Management | Communication & Collaboration</li>
          <li>Assessment of divisions of the Ocean Campus that are profit-generative to create sustainability and an improved offering</li>
          <li>Develop and execute the Foundation’s business plans to attain the vision and goals of the organisation</li>
          <li>Oversee the Foundation’s financial performance. Responsible for the control and reduction of operational costs</li>
          <li>Secure funding through grants, sponsorships, and partnerships to support educational programmes</li>
          <li>Develop, maintain, and continuously improve company policies and protocols</li>
          <li>Communicate and maintain trust relationships with stakeholders, partners and donors Inspire, motivate and lead the campus team in achieving the Foundation’s vision</li>
          <li>Oversee the marketing and sales of the Ocean Campus programmes</li>
          <li>Manage Human Resources, ensure employees work productively and develop professionally, oversee recruitment and training of new employees</li>
        </ul>


        <h3>TEARS Animal Rescue 🐕🐈</h3>
        As the General Manager of TEARS Animal Rescue, I offered a track record of excellence in team leadership, resource allocation, and programme management,
        coupled with exceptional community engagement abilities and strategic decision-making expertise.

        In my role, I spearheaded the development and execution of strategic plans and company policies, ensuring operations aligned with organisational objectives while navigating necessary change management.
        I led a team of 85 staff and over 150 volunteers. I nurtured stakeholder relationships, and drove the overall success and growth of the organisation.





        <h3>Writer/Story Teller 📖</h3>
        Joining my husband on an international assignment and the onset and subsequent lockdown due to Covid meant I suddenly had a lot of free time.
        This was the perfect opportunity to explore my creative side.
        As a natural storyteller and writer, I created a brand featuring a collection of animal characters, each conveying unique life lessons.
        The Mongoose Café is a Children’s Picture Book series and a YouTube channel dedicated to educational storytelling.
        Storytime stimulates a child’s imagination and expands knowledge and views of the wider world,
        building on their much-needed foundation and social skills. Stories are magic and take us on different journeys.

        For my children’s books, have a look <a href='https://www.amazon.com/dp/B09WFYLW8D?binding=paperback&ref=dbs_m_mng_rwt_sft_tpbk_tkin' target='_blank' rel="noreferrer">here</a>, and please visit my YouTube Channel: <a href='https://www.youtube.com/@themongoosecafe' target='_blank' rel="noreferrer"> The Mongoose Cafe</a>.

        <h3>The Arthritis Foundation of South Africa ⚕️</h3>
        CEO at the Arthritis Foundation of South Africa, a National organisation servicing Southern Africa.

        I was responsible for managing the Foundation’s overall operations. This included delegating and directing agendas, driving profitability, managing organisational structure and strategy, and communicating with the board.

        I am versatile and highly adaptable, with a proven track record as an executive with a reputation for setting high expectations. I initiated and supported organisational transformation and change, and one vital focus area was empowering communities through education. One of my first mandates was to implement a corporate governance framework. The strategy incorporated three main components, i.e., HR, Business Policies (financials, operations, etc.), and Marketing (rebranding and a new corporate identity).

        My framework resulted in a 30% reduction in expenditure and a 125% increase in donor funding.

        My favorite job in the office was to inspire the Team to deliver on the organisational mandate, grow, and constantly stretch themselves. I feel it’s essential to create a work environment that encourages, empowers, motivates, and inspires all who work or visit there. I’m into relationship building and working with civil society, business, academia, government, and the international community.

        I’m a planner and organiser of note!!

        <h3>The University of Salzburg 🎓</h3>
        I loved being part of the UNIGIS Network.  I was proud to be the Director of Sub-Saharan Africa for 22 years, leading and mentoring students and staff from all over Africa and the Middle East.  The program was first run by the Nelson Mandela University (previously P E Technikon) and then with the University of Salzburg.
        I worked with and led a fantastic group of colleagues, staff, and students.  I was accountable to the board of directors for the day-to-day running of UNIGIS Sub-Saharan Africa.
        I managed relationships with worldwide Units, including developing strategies to enable the organisation to build business opportunities, thereby generating revenue.
        Delivering operational management, including business and financial management, contract negotiation, mentoring, and training, was part and parcel of my daily functions.
        Operational management also included recruiting, interviewing, and selecting staff with the right technical and personal abilities to help further the organisation’s mission.

        I coordinated the entire student recruitment process (admissions) for national, SADC, and international students.

        I participated as a guest lecturer and panelist at various international institutions, societies, and events, which I always enjoyed.

        I don’t want to blow my own horn, BUT… I was named a UNIGIS International Fellow in 2017 (<a href='http://unigis.net/news/ann-olivier-named-unigis-international-fellow/' target='_blank' rel="noreferrer">Reference 1 </a>
        and <a href='https://unigis.net/honorarius-fellows/' target='_blank' rel="noreferrer">reference 2</a>)   I was the first (and so far only) woman to be given this distinction  💄 🏆
      </p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />



    </div>
  );
};

export default Work;